import React from "react";
import { useTranslation } from "react-i18next";

function LanguageChange() {
  const { i18n } = useTranslation();
  return (
    <div className="select">
      <select
        value={i18n.language}
        onChange={(e) =>
          i18n.changeLanguage(e.target.value)
        }
      >
        <option value="en">English</option>
      <option value="de">Deutsch</option>
      <option value="pl">polski</option>
      <option value="es">español, castellano</option>
      <option value="nl">Nederlands, Vlaams</option>
      <option value="fr">français, langue française</option>
      <option value="ru">русский язык</option>
      <option value="it">Italiano</option>
      <option value="pt">Português</option>
      <option value="tr">Türkçe</option>
      <option value="sv">svenska</option>
      <option value="da">dansk</option>
      <option value="fi">suomi, suomen kieli</option>
      <option value="no">Norsk</option>
      <option value="el">Ελληνικά</option>
      <option value="uk">українська</option>
      </select>
    </div>
  );
}
export default LanguageChange;